import React, { useState, useEffect } from "react";
import "./Header.css";
import Logo from "../../assets/img/logo.jpeg";
import { Link } from "react-scroll";
import whatsapp from "../../assets/img/whatsapp";
// Import Icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const Header = () => {
  // to change burger classes
  const [burger_class, setBurgerClass] = useState("burger-bar unclicked");
  const [menu_class, setMenuClass] = useState("menu visible");
  const [isMenuClicked, setIsMenuClicked] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 768) {
        setMenuClass("menu hidden");
      } else {
        // You can adjust this value based on your requirements
        setMenuClass("menu visible");
      }
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Initial setup on component mount
    handleResize();

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // toggle burger menu change
  const updateMenu = () => {
    if (!isMenuClicked) {
      setBurgerClass("burger-bar clicked");
      setMenuClass("menu visible");
    } else {
      setBurgerClass("burger-bar unclicked");
      setMenuClass("menu hidden");
    }
    setIsMenuClicked(!isMenuClicked);
  };

    const handleMenuItemClick = () => {
       if (window.innerWidth <= 768) {
         setTimeout(() => {
           setBurgerClass("burger-bar unclicked");
           setMenuClass("menu hidden");
           setIsMenuClicked(false);
         }, 500);
       }
    };

  return (
    <>
      <div className="header">
        <a href="/">
          <img className="logo" src={Logo} alt="Logo" />
        </a>
        <div className="navigation">
          <nav className="hidden">
            <div className="burger-menu" onClick={updateMenu}>
              <div className={burger_class}></div>
              <div className={burger_class}></div>
              <div className={burger_class}></div>
            </div>
          </nav>

          <ul className={menu_class}>
            <li>
              <Link
                to="services"
                span={true}
                smooth={true}
                offset={-100}
                onClick={handleMenuItemClick}
              >
                SERVICIOS
              </Link>
            </li>
            <li>
              <Link
                to="clients"
                span={true}
                smooth={true}
                offset={-80}
                onClick={handleMenuItemClick}
              >
                CLIENTES
              </Link>
            </li>
            <li className="first-menu">
              <Link
                to="knowus"
                span={true}
                smooth={true}
                offset={-80}
                onClick={handleMenuItemClick}
              >
                EQUIPO
              </Link>
            </li>
            <li className="last-item-h">
              <Link
                to="contact"
                span={true}
                smooth={true}
                offset={-80}
                onClick={handleMenuItemClick}
              >
                CONTACTO
              </Link>
            </li>
            <li className="whatsapp-li">
              <a href="https://wa.me/+59891035434" target="blank">
                <img src={whatsapp} className="img whatsapp-btn" alt="" />
              </a>
            </li>
          </ul>
        </div>
        <a
          href="https://wa.me/+59891035434"
          class="float"
          target="_blank"
          rel="noreferrer"
        >
          <FontAwesomeIcon icon={faWhatsapp} className="my-float" />
        </a>
      </div>
    </>
  );
};

export default Header;
